// all events must be registered in the Tracking Plan
// https://docs.google.com/spreadsheets/u/1/d/1gcZzRQ0O5vK-wF1FfGrjCk7Y3_-DFukS19w9iU6tUKY/edit#gid=639423297

export const EVENT_LABELS = {
  // General
  pageViewed: 'Page View',

  // Pedagogical Operations
  contentChanged: 'Content Changed',

  // Academic Operations
  couseEnrollmentDone: 'User Course Enrolled',
  disciplineEnrollmentDone: 'User Discipline Enrolled',
  userSearched: 'User Searched',

  // Project-specific (i.e. components, UI/UX)
  courseTreeOpened: 'Course Tree Opened',
  treeOrientationChanged: 'Tree Orientation Changed',

  // Discursive Exercise Evaluation
  discursiveExerciseEvaluated: 'Discursive Exercise Evaluated',
};
